import { render, staticRenderFns } from "./Expert2OrganizationList.vue?vue&type=template&id=5a2ce784&scoped=true&"
import script from "./Expert2OrganizationList.vue?vue&type=script&lang=js&"
export * from "./Expert2OrganizationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2ce784",
  null
  
)

export default component.exports